/* Page produit custom — slider galerie (swipe natif + miniatures + chevrons)
   et sélection de variante par pills */
(function () {
  const section = document.querySelector('.product-custom');
  if (!section) return;

  /* --- Galerie / slider --- */
  const gallery = section.querySelector('.product-custom__gallery');
  const stage = gallery ? gallery.querySelector('[data-slider]') : null;
  if (stage) {
    const slides = stage.querySelectorAll('.product-custom__slide');
    const thumbs = gallery.querySelectorAll('.product-custom__thumb');

    const currentIndex = () => Math.round(stage.scrollLeft / stage.clientWidth);

    const goTo = (index) => {
      const clamped = Math.max(0, Math.min(slides.length - 1, index));
      stage.scrollTo({ left: clamped * stage.clientWidth, behavior: 'smooth' });
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => goTo(Number(thumb.dataset.index)));
    });

    gallery.querySelectorAll('.product-custom__chevron').forEach((chevron) => {
      chevron.addEventListener('click', () => goTo(currentIndex() + Number(chevron.dataset.direction)));
    });

    /* Synchronise la miniature active pendant le scroll/swipe */
    let scrollTimer;
    stage.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        const index = currentIndex();
        thumbs.forEach((thumb) => {
          thumb.classList.toggle('is-active', Number(thumb.dataset.index) === index);
        });
      }, 80);
    }, { passive: true });
  }

  /* --- Variantes --- */
  const variantsScript = section.querySelector('[data-product-variants]');
  const form = section.querySelector('.product-custom__form');
  if (!variantsScript || !form) return;

  const variants = JSON.parse(variantsScript.textContent);
  const idInput = form.querySelector('[name="id"]');
  const priceEl = section.querySelector('.product-custom__price');
  const submitButton = form.querySelector('[type="submit"]');
  const submitText = submitButton ? submitButton.querySelector('span') : null;

  const selectedOptions = () => {
    const values = [];
    form.querySelectorAll('.product-custom__pill-input:checked').forEach((input) => {
      values[Number(input.dataset.optionPosition) - 1] = input.value;
    });
    return values;
  };

  const syncVariant = () => {
    const options = selectedOptions();
    const variant = variants.find((v) => v.options.every((value, i) => value === options[i]));
    if (!variant) return;

    idInput.value = variant.id;
    if (priceEl) priceEl.textContent = variant.price;
    if (submitButton && submitText) {
      if (variant.available) {
        submitButton.removeAttribute('disabled');
        submitText.textContent = window.variantStrings.addToCart;
      } else {
        submitButton.setAttribute('disabled', 'disabled');
        submitText.textContent = window.variantStrings.soldOut;
      }
    }
  };

  form.querySelectorAll('.product-custom__pill-input').forEach((input) => {
    input.addEventListener('change', syncVariant);
  });

  syncVariant();
})();
